import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import AmbientBackground from '../common/AmbientBackground';
import Button from '../common/Button';

const StartPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <AmbientBackground backgroundImage="/bg-still-warm.png" className="min-h-[calc(100vh-8rem)]">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="max-w-4xl mx-auto px-6 py-12"
      >
        <div className="text-center mb-10">
          <h1 className="font-display text-4xl md:text-5xl font-semibold text-ink dark:text-parchment mb-4">
            Welcome to Your Tarot Journey
          </h1>
          <p className="text-lg text-ink/90 dark:text-parchment/60">
            Choose how you'd like to begin your journey with the cards.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="bg-vellum dark:bg-shadow/60 border border-mist dark:border-dusk rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-sun dark:text-ember mb-4">
              New to Tarot?
            </h3>
            <p className="text-ink dark:text-parchment/60 mb-6">
              Start with a guided experience that will walk you through your first reading step by step. Perfect for beginners!
            </p>
            <Button
              variant="primary"
              size="lg"
              fullWidth
              onClick={() => navigate('/guided')}
            >
              Beginner? Start here
            </Button>
          </div>

          <div className="bg-vellum dark:bg-shadow/60 border border-mist dark:border-dusk rounded-xl p-6">
            <h3 className="text-xl font-display font-bold text-sun dark:text-ember mb-4">
              Ready to Dive In?
            </h3>
            <p className="text-ink dark:text-parchment/60 mb-6">
              Jump right into your Tarot Center where you can start readings, explore cards, and track your journey.
            </p>
            <Button
              variant="secondary"
              size="lg"
              fullWidth
              onClick={() => navigate('/center')}
            >
              Jump into Your Tarot Center
            </Button>
          </div>
        </div>

        <div className="mt-8 text-center space-x-4">
          <Link
            to="/guide/101"
            className="text-sun dark:text-ember hover:text-sun dark:hover:text-ember"
          >
            Tarot 101
          </Link>
          <span className="text-mist">•</span>
          <Link
            to="/about"
            className="text-sun dark:text-ember hover:text-sun dark:hover:text-ember"
          >
            About Tara
          </Link>
          <span className="text-mist">•</span>
          <Link
            to="/faq"
            className="text-sun dark:text-ember hover:text-sun dark:hover:text-ember"
          >
            About This App
          </Link>
        </div>
      </motion.div>
    </AmbientBackground>
  );
};

export default StartPage;
